export default __webpack_public_path__ + "static/media/1.b71210d1.png";